module.exports = __webpack_public_path__ + "static/media/cd2-icon-imprisonment.3d4eba38.svg";